import React from 'react';
import { useTranslation } from 'react-i18next';
import { panelGridFieldClassName } from '../propertyPanelUtils';
import NumberField from './NumberField';

type RotationFieldProps = {
  value: number | string;
  placeholder?: string;
  fieldClassName?: string;
  onChange: (degrees: number) => void;
};

const RotationField: React.FC<RotationFieldProps> = ({
  value,
  placeholder,
  fieldClassName = panelGridFieldClassName,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <NumberField
      label={t('propertyPanel.rotation')}
      fieldClassName={fieldClassName}
      min={0}
      max={359}
      value={value}
      placeholder={placeholder}
      onChange={(nextValue) => onChange(parseFloat(nextValue))}
    />
  );
};

export default RotationField;
